import { generateURLWithParams } from 'utils';
import http from 'utils/http';

export const fetchSalesReport = (query) => {
  const url = generateURLWithParams('v1/organizations/{{organizationId}}/reports/', query);
  return http.get(url);
};
